import React from 'react';
//import { getContrastColor } from '../../utils/colorUtils';

/**
 * Vertical tab component for document navigation
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Tab title
 * @param {boolean} props.isActive - Whether this tab is active
 * @param {boolean} props.isDirty - Whether the document has unsaved changes
 * @param {string} props.colorCode - Color code for the tab
 * @param {Function} props.onClick - Click handler
 * @param {Function} props.onClose - Close handler
 * @returns {JSX.Element} - Rendered component
 */
function VerticalTab({ 
  title, 
  isActive = false, 
  isDirty = false, 
  colorCode = '#ccc',
  onClick, 
  onClose 
}) {
  //const textColor = getContrastColor(colorCode);
  
  return (
    <div 
      className={`vertical-tab ${isActive ? 'active' : ''}`}
      style={{ 
        position: 'relative',
        padding: '8px 16px',
        marginBottom: '3px',
        borderLeft: `3px solid ${colorCode}`,
        backgroundColor: isActive ? '#f5f5f5' : 'transparent',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        borderRadius: '0 3px 3px 0',
        boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '170px',
        fontSize: '12px'
      }}
      onClick={onClick}
    >
      <div style={{ 
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '130px',
        display: 'flex',
        alignItems: 'center'
      }}>
        {/* Color indicator dot */}
        <div style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: colorCode,
          marginRight: '6px',
          border: `1px solid ${isActive ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.05)'}`
        }} />
        
        {/* Title with unsaved indicator */}
        <span>
          {title}
          {isDirty && (
            <span style={{ 
              marginLeft: '3px',
              fontSize: '12px',
              color: isActive ? '#888' : '#aaa'
            }}>•</span>
          )}
        </span>
      </div>
      
      {/* Close button */}
      <button 
        className="close-button"
        onClick={onClose}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: '#888',
          fontSize: '12px',
          cursor: 'pointer',
          padding: '1px 4px',
          marginLeft: '3px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isActive ? 1 : 0.5
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        ×
      </button>
    </div>
  );
}

export default VerticalTab;